<template>
  <div class="card-body px-0 pt-0 pb-2 vh-50">
    <div class="container py-4">
      <div class="row">
        <div class="col-md-12 text-end">
          <button
            class="btn bg-gradient-info btn-xs"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            <i class="ri-add-line me-1"></i>
            Nuevo obligado
          </button>
        </div>
        <div class="col-12">
          <NoDataComponent
            v-if="!obligadosSolidarios || obligadosSolidarios.length == 0"
          />
          <div v-else class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Obligado solidario
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Actividad
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Celular
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Teléfono
                  </th>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                  >
                    Residencia
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Notario
                  </th>
                  <th class="text-secondary opacity-7"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obligado in obligadosSolidarios" :key="obligado.id">
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div>
                        <div
                          class="text-center shadow icon icon-shape icon-sm bg-gradient-info me-3"
                        >
                          <i class="ri-user-star-line opacity-10"></i>
                        </div>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm text-lowercase">
                          {{ obligado.nombre }}
                        </h6>
                        <p class="text-xs text-secondary mb-0">
                          {{ obligado.correo }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle">
                    <span class="text-secondary text-xs font-weight-bold"
                      ><h6 class="mb-0 text-sm text-captilize">
                        {{ obligado.actividad }}
                      </h6></span
                    >
                  </td>
                  <td class="align-middle">
                    <span class="text-secondary text-xs font-weight-bold">
                      {{ obligado.celular }}
                    </span>
                  </td>
                  <td class="align-middle">
                    <span class="text-secondary text-xs font-weight-bold">
                      {{ obligado.telefono }}
                    </span>
                  </td>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">
                      {{ obligado.nombre_municipio }}
                    </p>
                    <p class="text-xs text-secondary mb-0">
                      {{ obligado.nombre_estado }}
                    </p>
                  </td>
                  <td class="align-middle text-start text-sm">
                    <p class="text-xs font-weight-bold mb-0">
                      {{ obligado.notario }}
                    </p>
                    <p
                      class="text-xs text-secondary mb-0"
                      v-if="obligado.no_notaria != ''"
                    >
                      Notaría {{ obligado.no_notaria }}
                    </p>
                  </td>
                  <td class="align-middle text-center">
                    <a
                      href="#"
                      v-on:click="confirmDelete(obligado)"
                      class="text-secondary font-weight-bold text-xs btn-xs mb-0"
                      ><i class="ri-delete-bin-4-line me-1"></i>Eliminar
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            Obligado solidario
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="Close"
          ></button>
        </div>
        <form
          v-on:submit.prevent="storeObligadoSolidario"
          id="form-obligado"
          method="POST"
        >
          <div class="modal-body">
            <div class="col-12 row px-0 mx-0">
              <div class="form-group col-md-6">
                <label>Nombre*</label>
                <input
                  type="text"
                  class="form-control"
                  name="nombre"
                  autocomplete="off"
                  v-model="nombre"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label>Actividad*</label>
                <input
                  type="text"
                  class="form-control"
                  name="actividad"
                  autocomplete="off"
                  v-model="actividad"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label>Correo electrónico*</label>
                <input
                  type="email"
                  class="form-control"
                  name="correo"
                  placeholder="correo@ejemplo.com"
                  autocomplete="off"
                  v-model="correo"
                  required
                />
              </div>
              <div class="form-group col-md-3">
                <label>Celular</label>
                <input
                  type="tel"
                  class="form-control"
                  name="celular"
                  autocomplete="off"
                  v-model="celular"
                  maxlength="10"
                />
              </div>
              <div class="form-group col-md-3">
                <label>Teléfono</label>
                <input
                  type="tel"
                  class="form-control"
                  name="telefono"
                  autocomplete="off"
                  v-model="telefono"
                  maxlength="10"
                />
              </div>
              <div class="form-group col-md-3">
                <label>Fecha*</label>
                <input
                  type="date"
                  class="form-control"
                  name="fecha"
                  autocomplete="off"
                  v-model="fecha"
                  required
                />
              </div>
              <div class="form-group col-md-2">
                <label>Póliza</label>
                <input
                  type="text"
                  class="form-control"
                  name="poliza"
                  autocomplete="off"
                  v-model="poliza"
                />
              </div>
              <div class="form-group col-md-2">
                <label>No. Notaría</label>
                <input
                  type="text"
                  class="form-control"
                  name="notaria"
                  autocomplete="off"
                  v-model="notaria"
                />
              </div>
              <div class="form-group col-md-5">
                <label>Notario*</label>
                <input
                  type="text"
                  class="form-control"
                  name="notario"
                  autocomplete="off"
                  v-model="notario"
                  required
                />
              </div>
              <div class="form-group col-md-4">
                <label>Estado*</label>
                <select
                  name="estado"
                  v-model="estado"
                  class="form-control"
                  required
                  @change="getMunicipiosByEstado($event.target.value)"
                >
                  <option value="">Seleccione</option>
                  <option
                    v-for="estado in estados"
                    :key="estado.id"
                    :value="estado.id"
                  >
                    {{ estado.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Municipio*</label>
                <select
                  name="municipio"
                  v-model="municipio"
                  class="form-control"
                  required
                >
                  <option value="">Seleccione</option>
                  <option
                    v-for="municipio in municipios"
                    :value="municipio.id"
                    :key="municipio.id"
                  >
                    {{ municipio.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>País*</label>
                <select
                  name="pais"
                  v-model="pais"
                  class="form-control"
                  required
                >
                  <option value="MEXICO">México</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn bg-gradient-primary btn-sm"
              :disabled="isLoadingSubmit"
            >
              <span
                v-if="isLoadingSubmit"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Guardar
            </button>
            <button
              type="button"
              class="btn bg-gradient-danger btn-sm"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  showToast,
  exceptionRequestMsg,
  confirmDialog,
} from "@/assets/js/util";
import NoDataComponent from "@/components/NoDataComponent.vue";
import appApi from "@/services/api";

export default {
  name: "cliente-obligados",
  components: {
    NoDataComponent,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
    },
    clienteObligados: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    estados: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoadingSubmit: false,
      municipios: [],
      obligadosSolidarios: this.clienteObligados,
      nombre: "",
      actividad: "",
      correo: "",
      celular: "",
      telefono: "",
      fecha: "",
      poliza: "",
      notaria: "",
      notario: "",
      estado: "",
      municipio: "",
      pais: "",
    };
  },
  methods: {
    async getClientesObligados(cliente_id = this.cliente.id) {
      this.obligadosSolidarios = [];
      try {
        const response = await appApi().get(
          `clientes/obligados-solidarios/${cliente_id}`
        );
        this.obligadosSolidarios = response.data;
      } catch (e) {
        exceptionRequestMsg(e);
      }
    },
    async storeObligadoSolidario() {
      this.isLoadingSubmit = true;
      console.log("Ejecutamos store");
      const form = document.getElementById("form-obligado");
      const formData = new FormData(form);
      formData.append("cliente_id", this.cliente.id);

      try {
        const response = await appApi().post(
          "clientes/obligados-solidarios/store",
          formData
        );

        const { status, message } = response.data;
        this.isLoadingSubmit = false;

        if (!status) {
          showToast(message, "error");
          return;
        }

        this.$refs.Close.click();
        await this.getClientesObligados();
        showToast(message, "success");
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },
    async getMunicipiosByEstado(estado_id) {
      try {
        this.municipio = "";
        this.municipios = [];
        if (estado_id == "") return;
        console.log("Consultando municipios");
        //this.showSpinnerMunicipio = true;
        const response = await appApi().get(`municipios/${estado_id}`);
        this.municipios = response.data;
        //this.showSpinnerMunicipio = false;
        return response.data;
      } catch (e) {
        //this.showSpinnerMunicipio = false;
        console.error(e);
      }
    },
    async confirmDelete(obligado) {
      confirmDialog({
        html: `Se eliminará permanentemente a <b><u>${obligado.nombre}</u></b> como obligado solidario.`
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await appApi().delete(
              `clientes/obligados-solidarios/destroy/${obligado.id}`
            );

            const { status, message } = response.data;
            if (!status) {
              showToast(message, "error");
              return;
            }

            showToast(message, "success");
            this.getClientesObligados();
          } catch (e) {
            exceptionRequestMsg(e);
          }
        }
      });
    },
  },
};
</script>

<style></style>
